import _ from 'lodash';
import {useMemo} from 'react';

import {isDefined} from '../../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {CustomFieldResourceTypesEnum} from '../../../../models/api/customFieldModel';
import {AppState} from '../../../../store/appState';
import {makeGetCustomFieldsForResource} from '../../../../store/data/customFields/customFieldsSelectors';

export function useCustomFields(customFieldResourceType: CustomFieldResourceTypesEnum) {
  const getCustomFieldsForResource = useMemo(makeGetCustomFieldsForResource, []);
  const customFieldObjects = useAppSelector((state: AppState) =>
    getCustomFieldsForResource(state, customFieldResourceType),
  );
  const customFields = _.values(customFieldObjects).filter(isDefined);

  return customFields;
}
